import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A tall slender birch — a pale tapered-capsule trunk with graphic dark bark
// chips (kept chunky) and a light, airy canopy of soft leaf balls (rounded art
// style, plan 28 stage 4).
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/birch.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ box, bone, ball, seed }) => {
    const h = 3.4 + rand(seed) * 1.8;
    // pale trunk — slender tapered capsule, base cap sunk slightly into grade
    const rBase = 0.2, rTop = 0.14;
    bone(0, 0.1, 0, 0, h, 0, rBase, rTop, 0xe8e4d8);
    // dark bark bands — graphic chunky chips proud of the rounded trunk surface
    const bands = 3 + Math.floor(rand(seed + 1) * 3);
    for (let i = 0; i < bands; i++) {
      const by = (rand(seed + i * 3) * 0.7 + 0.1) * h;
      const tr = rBase + (rTop - rBase) * (by / h); // trunk radius at this height
      box(0, by, tr + 0.01, 0.3, 0.06 + rand(seed + i) * 0.05, 0.05, 0x33312b);
    }
    // light canopy — a few soft green leaf balls near the top
    const leaf = shade(0x7aa653, (rand(seed + 2) - 0.5) * 0.2);
    const clumps = 3 + Math.floor(rand(seed + 3) * 2);
    for (let i = 0; i < clumps; i++) {
      const a = rand(seed + i * 5) * Math.PI * 2;
      const rr = rand(seed + i * 5 + 1) * 0.8;
      ball(Math.cos(a) * rr, h - 0.2 + rand(seed + i) * 0.8, Math.sin(a) * rr,
        0.8, shade(leaf, (rand(seed + i) - 0.5) * 0.15), 0.95 + rand(seed + i * 5 + 2) * 0.1);
    }
  };

export default build;
